<pk-web-loader [show]="loading"></pk-web-loader>
<div class="row" *ngIf="!loading">
	<div class="col logo-crawl">
		<div class="logo-crawl-inner">
			<img *ngFor="let supplier of webSupplierMetrics" [src]="supplier.logo" class="img-fluid" [attr.alt]="supplier.name" />
		</div>
	</div>
</div>
